import { isNil } from 'lodash';
import * as productService from 'services/productService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRProductsData = Awaited<ReturnType<typeof productService.getProductDetailAsync>>;

const useProduct = (
  productId: number,
  load?: boolean
): SWRResponse<SWRProductsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_PRODUCT_ENDPOINT, productId] : null,
    async ([_, params]) => await productService.getProductDetailAsync(params)
  );

export const SWR_PRODUCT_ENDPOINT = 'product';
export default useProduct;
